export default "__VITE_ASSET__6426646e__"